import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import 'rxjs/Rx';
import { DialogRef, ModalComponent, CloseGuard } from 'angular2-modal';
import { Overlay, overlayConfigFactory } from 'angular2-modal';
import { TranslateService } from 'ng2-translate/ng2-translate';

import { UserService } from '../../../../_services/userservice/user.service';
import { utilityService } from '../../../../sharedcomponents/commonservice/utility.service';
import { UserInfoComponent } from '../user-info/user-info.component';
import { AppSettings, enumStatusCodeList } from '../../../../sharedcomponents/_common/constants/app.constants';
import { User } from '../../../../models/user/user';
import { AlertService } from '../../../../sharedcomponents/commonservice/alert.service';
export class CustomModalContext extends BSModalContext {
  // public user: User;
  public modalData: any;
}

@Component({
  selector: 'app-verify-mobile',
  templateUrl: './verify-mobile.component.html',
  styleUrls: ['./verify-mobile.component.css'],
  providers: [UserService, AppSettings, AlertService]
})
export class VerifyMobileComponent implements ModalComponent<CustomModalContext> {
  context: CustomModalContext;
  model: any = {};
  loading = false;


  constructor(
    public dialog: DialogRef<CustomModalContext>,
    private translate: TranslateService,
    private router: Router,
    public modal: Modal,
    private alertService: AlertService,
    private userService: UserService,
    private utilserv: utilityService
  ) {
    this.context = dialog.context;
    this.model = this.context.modalData.user;
  }

  verfyMobileClick() {
    this.model.MethodName = 'SMS';
    let responseMessage = '';
    this.userService.verifyUserMobile(this.model).subscribe(data => {
      let resJSON = data;
      if (resJSON.Envelope.Body.ResponseBase.StatusCode == enumStatusCodeList.SUCCESS) {
        // this.openInfoPopup(resJSON.Envelope.Body.ResponseBase.StatusMessage);
        this.context.modalData.next = 'yes';
        this.dialog.close();
      } else if (resJSON.Envelope.Body.ResponseBase.StatusCode == enumStatusCodeList.InvalidOTP) {
        this.alertService.openErrorAlert(this.translate.instant('Common_lblOops'), resJSON.Envelope.Body.ResponseBase.StatusMessage);
      } else if (resJSON.Envelope.Body.ResponseBase.StatusCode == enumStatusCodeList.OTPExpier) {
        // OTP Expire
        this.alertService.openErrorAlert(this.translate.instant('Common_lblOops'), resJSON.Envelope.Body.ResponseBase.StatusMessage);
      } else if (resJSON.Envelope.Body.ResponseBase.StatusCode == enumStatusCodeList.EmailNotVerified) {
        const message = this.translate.instant('EmailConfirmPopup_desc');
        this.loading = false;
        this.openInfoPopup(message);
      } else {
        this.alertService.openErrorAlert(this.translate.instant('Common_lblOops'), resJSON.Envelope.Body.ResponseBase.StatusMessage);
      }
    });
  }

  openInfoPopup(message: string) {
    this.dialog.close();
    let infoMessage = message;
    return this.modal.open(UserInfoComponent, overlayConfigFactory({ infoMessage }, BSModalContext));
  }
  closePopup() {
    this.dialog.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/user/user-register/RegistrationPopup/verify-mobile/verify-mobile.component.ts